export class UpdateRestoreAccountConnectivityConfigResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountConfig",
            "baseName": "restoreAccountConfig",
            "type": "RestoreAccountConnectivityConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateRestoreAccountConnectivityConfigResponse.attributeTypeMap;
    }
    constructor() {
    }
}
